
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { stockpool } from '@/api/index'
import { QUANT_GOLD_TRACK_PERIODS } from './quantGoldMock'

interface QuantGoldModelReturnRow {
  period: string
  totalProfitLossRatio: number | null
  avgHoldDays: number | null
  sellAvgProfit: number | null
  sellAvgLoss: number | null
}

export default defineComponent({
  name: 'QuantGoldBacktest',
  props: {
    theme: { type: String, default: 'light' }
  },
  setup() {
    const route = useRoute()
    const loading = ref(false)

    const modelReturnData = ref<QuantGoldModelReturnRow[]>(
      QUANT_GOLD_TRACK_PERIODS.map(p => ({
        period: p.label,
        totalProfitLossRatio: null,
        avgHoldDays: null,
        sellAvgProfit: null,
        sellAvgLoss: null
      }))
    )

    const getRequestHeaders = () => ({
      clienttype: 'pc',
      appVersion: route.query.appVersion,
      token: route.query.token,
      'Content-Type': 'application/json'
    })

    const getTrackPayload = (res: any) => {
      if (!res) return null
      if (
        res.profitLossRatio != null ||
        res.avgHoldDays != null ||
        res.sellAvgProfit != null ||
        res.sellAvgLoss != null
      ) {
        return res
      }
      return res.data ?? null
    }

    const fetchData = async () => {
      loading.value = true
      try {
        const results = await Promise.all(
          QUANT_GOLD_TRACK_PERIODS.map(item =>
            stockpool.getQuantGoldTrack({
              data: { period: item.value },
              headers: getRequestHeaders()
            })
          )
        )

        results.forEach((res: any, index: number) => {
          const data = getTrackPayload(res)
          if (!data) return

          const periodLabel = QUANT_GOLD_TRACK_PERIODS[index].label

          modelReturnData.value[index] = {
            period: periodLabel,
            totalProfitLossRatio: data.profitLossRatio ?? null,
            avgHoldDays: data.avgHoldDays ?? null,
            sellAvgProfit: data.sellAvgProfit ?? null,
            sellAvgLoss: data.sellAvgLoss ?? null
          }
        })
      } catch (e) {
        console.error('QuantGoldBacktest fetchData failed', e)
      } finally {
        loading.value = false
      }
    }

    onMounted(fetchData)

    const formatDays = (val: number | null | undefined) => {
      if (val === null || val === undefined) return '--'
      return val.toFixed(1) + '天'
    }

    const formatProfitLossRatio = (val: number | null | undefined) => {
      if (val === null || val === undefined) return '--'
      return val.toFixed(2)
    }

    const formatPercent = (val: number | null | undefined) => {
      if (val === null || val === undefined) return '--'
      return (val * 100).toFixed(2) + '%'
    }

    const getPopupContainer = () => document.body

    return {
      loading,
      modelReturnData,
      formatDays,
      formatProfitLossRatio,
      formatPercent,
      getPopupContainer
    }
  }
})
